import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import InputTextOutlined from '@components/InputTextOutlined';
import PrimaryButton from '@components/PrimaryButton';
import { useAuthContext, useToastNotificationContext } from '@hooks';
import { switchBetweenLabelAndPlaceholder } from '@utils';

const VerifyCode = ({ email }) => {
  const history = useHistory();
  const { t } = useTranslation(['pointOfService', 'auth']);
  const { setToastNotification } = useToastNotificationContext();

  const [
    isPlaceholderVerificationCodeShow,
    setPlaceholderVerificationCodeShow,
  ] = useState(true);
  const [isLabelVerificationCodeShow, setLabelVerificationCodeShow] = useState(
    false,
  );
  const [verificationCode, setVerificationCode] = useState('');
  const [isErrorVerifyCode, setErrorVerifyCode] = useState(false);
  const [errorMessageVerifyCode, setErrorMessageVerifyCode] = useState('');
  const { verifyEmailWithCode, staffCheckIn, closeSession } = useAuthContext();

  const showCancelButton = false;

  const redirectToLandingPage = async () => {
    const isSessionClosed = await closeSession();
    if (isSessionClosed) {
      setToastNotification({
        isShowToast: true,
        toastType: 'info',
        toastMessage: t('auth:cancelledAuthorization'),
        toastKeyTranslate: '',
        errorCode: '',
      });

      history.push('/');
    }
  };

  const handleChangeVerificationCode = ({ target }) => {
    setVerificationCode(target.value);

    switchBetweenLabelAndPlaceholder({
      condition: target.value.length > 0,
      setLabel: setLabelVerificationCodeShow,
      setPlaceholder: setPlaceholderVerificationCodeShow,
    });
  };

  // const copyInputVal = () => {
  //   console.log(otpCode);
  //   setVerificationCode(otpCode.toString().replaceAll(',', ''));
  //   // myRef.current = otpCode.toString().replaceAll( ",", "" );
  // };
  //
  // const handleChangeSingleDigit = ({ target }) => {
  //   let el_val = String(target.value);
  //   if (el_val.length > 0) {
  //     if (el_val.length > 1) {
  //       target.value = el_val.charAt(el_val.length - 1);
  //     }
  //     let form = target.form;
  //     let index = [...form].indexOf(target);
  //     otpCode[index] = target.value;
  //     console.log('target.value', target.value);
  //     console.log('otpCode[index]', otpCode[index])
  //     console.log('index', index)
  //     copyInputVal();
  //     if (typeof form.elements[index + 1] !== 'undefined') {
  //       form.elements[index + 1].focus();
  //     }
  //   }
  // };

  const handleDisplayPlaceholderInputCode = () => {
    setPlaceholderVerificationCodeShow(!isPlaceholderVerificationCodeShow);
  };

  const handleDisplayLabelOrPlaceholderCode = () => {
    if (verificationCode.length > 0) {
      setLabelVerificationCodeShow(true);
    } else {
      setPlaceholderVerificationCodeShow(true);
    }
  };

  const sendVerifyCode = async () => {
    const verifyStatus = await verifyEmailWithCode({
      email,
      code: verificationCode,
    });

    if (!verifyStatus) {
      setErrorVerifyCode(true);
      setErrorMessageVerifyCode(verifyStatus.message);
      return history.push('/auth');
    }
    const stringifyPlaceData = localStorage.getItem('place');
    const { placeId } = JSON.parse(stringifyPlaceData);

    const response = await staffCheckIn(placeId);

    if (response.error) {
      setToastNotification({
        isShowToast: true,
        toastType: 'warning',
        toastMessage: response.error.message,
        toastKeyTranslate: '',
        errorCode: '',
      });
    }

    if (!response) return history.push('/auth');

    history.push(`/service/${placeId}/orders`, {
      from: `/service/${placeId}/login`,
    });
  };

  return (
    <div className="auth-bg" style={{ color: '#fff' }}>
      <div className="auth-box">
        <h2>Please verify its you</h2>
        <div className="note">
          <p>
            We’ve sent a 6-character code to <br></br>
            <span>{email}</span>
          </p>
          <p>
            The code expires shortly, so <br></br>please enter it soon
          </p>
        </div>
        <div className="otp-ver">
          <div style={{ align: 'center' }}>
            <center>
              <InputTextOutlined
                type="number"
                styles={{ width: '355px' }}
                pattern="[0-9]*"
                value={verificationCode}
                placeholder={t('auth:signIn.verificationCode')}
                handleChangeInput={handleChangeVerificationCode}
                handleDisplayPlaceholderInput={
                  handleDisplayPlaceholderInputCode
                }
                handleDisplayLabelOrPlaceholder={
                  handleDisplayLabelOrPlaceholderCode
                }
                isPlaceholderInputDisplayed={isPlaceholderVerificationCodeShow}
                isLabelInputDisplayed={isLabelVerificationCodeShow}
              />
            </center>
          </div>
          {/*<div className="frm-container">*/}
          {/*  <form className="frm-otp otp-ver">*/}
          {/*    <InputTextOutlined*/}
          {/*      minlength="1"*/}
          {/*      maxlength="1"*/}
          {/*      type="number"*/}
          {/*      handleChangeInput={handleChangeSingleDigit}*/}
          {/*    />*/}
          {/*    <InputTextOutlined*/}
          {/*      minlength="1"*/}
          {/*      maxlength="1"*/}
          {/*      type="number"*/}
          {/*      handleChangeInput={handleChangeSingleDigit}*/}
          {/*    />*/}
          {/*    <InputTextOutlined*/}
          {/*      minlength="1"*/}
          {/*      maxlength="1"*/}
          {/*      type="number"*/}
          {/*      handleChangeInput={handleChangeSingleDigit}*/}
          {/*    />*/}
          {/*    <span className="dash"></span>*/}
          {/*    <InputTextOutlined*/}
          {/*      minlength="1"*/}
          {/*      maxlength="1"*/}
          {/*      type="number"*/}
          {/*      handleChangeInput={handleChangeSingleDigit}*/}
          {/*    />*/}
          {/*    <InputTextOutlined*/}
          {/*      minlength="1"*/}
          {/*      maxlength="1"*/}
          {/*      type="number"*/}
          {/*      handleChangeInput={handleChangeSingleDigit}*/}
          {/*    />*/}
          {/*    <InputTextOutlined*/}
          {/*      minlength="1"*/}
          {/*      maxlength="1"*/}
          {/*      type="number"*/}
          {/*      handleChangeInput={handleChangeSingleDigit}*/}
          {/*    />*/}
          {/*  </form>*/}
          {/*</div>*/}
        </div>
        <PrimaryButton text={t('Yassss')} handleClick={sendVerifyCode} />
        {showCancelButton ? (
          <PrimaryButton
            text={t('buttons.cancelButton')}
            handleClick={redirectToLandingPage}
          />
        ) : (
          ''
        )}

        {isErrorVerifyCode ? (
          <div style={{ textAlign: 'center', textTransform: 'capitalize' }}>
            {errorMessageVerifyCode}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default VerifyCode;
